import {
  put,
  takeLatest,
  all,
  call,
  // takeEvery,
  takeLeading
} from 'redux-saga/effects';
import {
  GET_CONTEST_LEADERBOARD,
  GET_MY_MATCH_TEAM_LIST,
  JOIN_CONTEST,
  GET_MY_LIVE_MATCHES,
  GET_MY_COMPLETED_MATCHES,
  GET_MY_UPCOMING_MATCHES,
  FANTASY_MATCH_CLICK,
  matchItem,
  UPCOMING_MATCH_LIST,
  GET_ALL_CONTEST_LIST,
  GET_MATCH_PLAYER_LIST,
  GET_MY_FIXTURE_JOINED_CONTEST_LIST,
  GET_MY_LIVE_JOINED_CONTEST_LIST,
  GET_MY_RESULT_JOINED_CONTEST_LIST,
  GET_CONTEST_DETAILS_BY_ID,
  GET_MATCH_DETAILS_BY_ID,
  GET_MY_RECENT_MATCHES,
  GET_MY_TEAM_DETAILS_BY_TEAM_ID,
  SWITCH_CONTEST_TEAM,
  setMyTeamList,
  CREATE_TEAM,
  EDIT_TEAM,
  GET_CONTEST_USER_LEADERBOARD,
  GET_CONTEST_TYPES,
  setContestTypes,
  GET_CONTEST_LIST_BY_CONTEST_TYPE,
  GET_CONTEST_LIST_BY_CATEGORY,
  GET_CONTEST_LIST_BY_CATEGORY_ID,
  GET_CONTEST_LIST_BY_CONTEST_TYPE_ID,
  JOIN_WITH_MULTIPLE_TEAM,
  ADD_SUBSTITUTE_PLAYER,
  GET_SUBSTITUTE_TEAM_BY_ID,
  setMyContestList
} from '../actions/fantasy-substitute-action-types';
import httpClient from './http-client';
import _ from 'lodash';
// import I18n from '../utilities/locale'
// import moment from 'moment'

function* getUpcomingMatchList({ payload: { data, callback } }) {
  const { skip, limit } = data;
  // const timestamp = moment().format('X')
  const payload = {
    method: 'GET',
    isCloudFrontURL: true,
    // eslint-disable-next-line max-len
    url: `fantasy-substitute/matches?filter={"limit":${limit},"skip":${skip},"order":["startDate ASC"],"where":{"$and":[{"$or": [{"status": 1},{"status": 3,"gameState": {"$in": [0, 1, 4]}}]}]}}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getContestTypes({ payload: { callback } }) {
  const payload = {
    // data: body,
    method: 'GET',
    url: '/fantasy-substitute/contest-types'
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
  if (!error && result && result.length) {
    let contestTypes = {};
    let contestTypeListById = _.groupBy(result, function (category) {
      return category.id;
    });
    for (let key in contestTypeListById) {
      // eslint-disable-next-line no-prototype-builtins
      if (contestTypeListById.hasOwnProperty(key)) {
        contestTypes[key] = contestTypeListById[key][0];
      }
    }
    yield put(setContestTypes(contestTypes));
  }
}

function* getAllContestList({ payload: { data, callback } }) {
  const { categoryId = '' } = data;
  const payload = {
    method: 'GET',
    isCloudFrontURL: false,
    url: categoryId
      ? `fantasy-substitute/matches/${data.matchId}/contests?contestCategoryId=${categoryId}&&filter={
        "offset": 0,
        "limit": 50,
        "skip": 0
      }`
      : `fantasy-substitute/matches/${data.matchId}/contests?filter={
        "offset": 0,
        "limit": 150,
        "skip": 0
      }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getContestListByContestType({ payload: { data, callback } }) {
  const payload = {
    // data: body,
    isCloudFrontURL: true,
    method: 'GET',
    url: `fantasy-substitute/matches/${data.matchId}/contests/group?filter={
      "offset": 0,
      "limit": 200,
      "skip": 0
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getContestListByContestTypeId({ payload: { data, callback } }) {
  const { contestTypeId = '', matchId = '' } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/${matchId}/contests/group?contestTypeId=${contestTypeId}filter={
      "offset": 0,
      "limit": 200,
      "skip": 0
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getContestListByCategory({ payload: { data, callback } }) {
  const payload = {
    // data: body,
    isCloudFrontURL: true,
    method: 'GET',
    url: `fantasy-substitute/matches/${data.matchId}/categories/group?filter={
      "offset": 0,
      "limit": 200,
      "skip": 0
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getContestListByCategoryId({ payload: { data, callback } }) {
  const { contestCategoryId = '', matchId = '' } = data;
  const payload = {
    isCloudFrontURL: true,
    method: 'GET',
    url: `fantasy-substitute/matches/${matchId}/categories/group?contestCategoryId=${contestCategoryId}filter={
      "offset": 0,
      "limit": 200,
      "skip": 0
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getPlayerList({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    isCloudFrontURL: true,
    url: `fantasy-substitute/matches/${data.matchId}/players`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMyUpcomingMatches({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/user-matches?filter={
      "limit":${limit},
      "skip":${skip},
      "order":["startDate ASC"],
      "where": {
        "status":1
      }
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMyLiveMatches({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/user-matches?filter={
      "limit":${limit},
      "skip":${skip},
      "order":["startDate DESC"],
      "where": {
        "status":3
      }
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMyCompletedMatches({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/user-matches?filter={
      "limit":${limit},
      "skip":${skip},
      "order":["startDate DESC"],
      "where": {
        "status":2
      }
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMyRecentMatches({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/user-matches?filter={
      "limit":5,
      "skip":0,
      "where": {
        "status":3
      }
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMyMatchTeamList({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/${data.matchId}/teams?filter={
      "limit":11
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  if (!error && result && result.length) yield put(setMyTeamList(result));
  callback({ result, error });
}

function* getMyFixtureJoinedContest({ payload: { data, callback } }) {
  const { skip, limit, matchId } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/${matchId}/user-scheduled-contests?filter={
      "limit":${limit},
      "skip":${skip}
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  if (!error && result) yield put(setMyContestList(result));
  callback({ result, error });
}

function* getMyLiveJoinedContest({ payload: { data, callback } }) {
  const { skip, limit, matchId } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/${matchId}/user-live-contests?filter={
      "limit":${limit},
      "skip":${skip}
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  if (!error && result) yield put(setMyContestList(result));
  callback({ result, error });
}

function* getMyResultJoinedContest({ payload: { data, callback } }) {
  const { skip, limit, matchId } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/${matchId}/user-completed-contests?filter={
      "limit":${limit},
      "skip":${skip}
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  if (!error && result) yield put(setMyContestList(result));
  callback({ result, error });
}

function* joinContest({ payload: { data, callback } }) {
  const { contestId = '', selectTeamId = '' } = data;
  const body = {
    matchTeamId: selectTeamId
  };
  const payload = {
    data: body,
    method: 'POST',
    url: `fantasy-substitute/contests/${contestId}/teams`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* getContestLeaderboard({ payload: { data, callback } }) {
  const { skip = 0, limit = 100 } = data;
  const payload = {
    method: 'GET',
    isCloudFrontURL: true,
    url: `fantasy-substitute/contests/${data.id}/leaderboard?filter={
      "limit":${limit},
      "skip":${skip}
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getContestUserLeaderboard({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/contests/${data.id}/user/leaderboard`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* fantasyMatchClick({ payload: { data } }) {
  yield put(matchItem({ ...data }));
}

function* getContestDetailsById({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/contests/${data.contestId}?filter={
      "offset": 0,
      "limit": 100,
      "skip": 0
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMatchDetailsById({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/matches/${data.id}?filter={
      "offset": 0,
      "limit": 100,
      "skip": 0
    }`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* switchContestTeam({ payload: { data, callback } }) {
  const { contestId = '', userTeamId = '', contestTeamId = '' } = data;
  const payload = {
    data: {
      matchTeamId: userTeamId
    },
    method: 'PATCH',
    url: `fantasy-substitute/contests/${contestId}/teams/${contestTeamId}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMyTeamDetailsByTeamId({ payload: { data, callback } }) {
  const { teamId = '' } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-substitute/teams/${teamId}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* createTeam({ payload: { data, callback } }) {
  const { matchId = '', players = [], captainId = '', viceCaptainId = '' } = data;
  const body = {
    players,
    captainId,
    viceCaptainId
  };
  const payload = {
    data: body,
    method: 'PUT',
    showHttpClientError: false,
    url: `/fantasy-substitute/matches/${matchId}/teams`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* editTeam({ payload: { data, callback } }) {
  const {
    teamId = '',
    players = [],
    captainId = '',
    viceCaptainId = '',
    substitutedCaptainId = '',
    substitutedViceCaptainId = ''
  } = data;

  let body = {
    players,
    captainId,
    viceCaptainId
  };
  if (substitutedCaptainId) {
    body = {
      ...body,
      substitutedCaptainId
    };
  }
  if (substitutedViceCaptainId) {
    body = {
      ...body,
      substitutedViceCaptainId
    };
  }

  const payload = {
    data: body,
    method: 'PUT',
    showHttpClientError: false,
    url: `/fantasy-substitute/teams/${teamId}`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* joinWithMultipleTeam({ payload: { data, callback } }) {
  const { contestId = '', teamList = [] } = data;
  const payload = {
    data: teamList,
    method: 'POST',
    url: `/fantasy-substitute/contests/${contestId}/multiple/teams`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* addSubstitutePlayer({ payload: { data, callback } }) {
  const { teamId = '', substitutedCaptainId = '', substitutedViceCaptainId = '' } = data;
  delete data.teamId;
  if (!substitutedCaptainId) delete data.substitutedCaptainId;
  if (!substitutedViceCaptainId) delete data.substitutedViceCaptainId;
  const payload = {
    data,
    method: 'PUT',
    url: `/fantasy-substitute/teams/${teamId}`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* getSubstituteTeamById({ payload: { data, callback } }) {
  const { teamId = '', isLoader = false } = data;
  delete data.isLoader;
  const payload = {
    // data,
    method: 'GET',
    url: `/fantasy-substitute/teams/${teamId}`
  };
  const { result, error } = yield call(httpClient, payload, isLoader);
  callback({ result, error });
}

function* fantasySubstitute() {
  yield all([
    yield takeLatest(GET_MY_UPCOMING_MATCHES, getMyUpcomingMatches),
    yield takeLatest(GET_MY_LIVE_MATCHES, getMyLiveMatches),
    yield takeLatest(GET_MY_COMPLETED_MATCHES, getMyCompletedMatches),
    yield takeLatest(GET_MY_RECENT_MATCHES, getMyRecentMatches),
    yield takeLatest(GET_MY_FIXTURE_JOINED_CONTEST_LIST, getMyFixtureJoinedContest),
    yield takeLatest(GET_MY_LIVE_JOINED_CONTEST_LIST, getMyLiveJoinedContest),
    yield takeLatest(GET_MY_RESULT_JOINED_CONTEST_LIST, getMyResultJoinedContest),
    yield takeLatest(GET_MY_MATCH_TEAM_LIST, getMyMatchTeamList),
    yield takeLeading(JOIN_CONTEST, joinContest),
    yield takeLatest(GET_CONTEST_LEADERBOARD, getContestLeaderboard),
    yield takeLatest(GET_CONTEST_USER_LEADERBOARD, getContestUserLeaderboard),
    yield takeLatest(FANTASY_MATCH_CLICK, fantasyMatchClick),
    yield takeLatest(UPCOMING_MATCH_LIST, getUpcomingMatchList),
    yield takeLatest(GET_ALL_CONTEST_LIST, getAllContestList),
    yield takeLatest(GET_MATCH_PLAYER_LIST, getPlayerList),
    yield takeLatest(GET_CONTEST_DETAILS_BY_ID, getContestDetailsById),
    yield takeLatest(GET_MATCH_DETAILS_BY_ID, getMatchDetailsById),
    yield takeLatest(GET_CONTEST_LIST_BY_CONTEST_TYPE_ID, getContestListByContestTypeId),
    yield takeLatest(GET_MY_TEAM_DETAILS_BY_TEAM_ID, getMyTeamDetailsByTeamId),
    yield takeLatest(SWITCH_CONTEST_TEAM, switchContestTeam),
    yield takeLeading(CREATE_TEAM, createTeam),
    yield takeLeading(EDIT_TEAM, editTeam),
    yield takeLatest(GET_CONTEST_TYPES, getContestTypes),
    yield takeLatest(GET_CONTEST_LIST_BY_CONTEST_TYPE, getContestListByContestType),
    yield takeLatest(GET_CONTEST_LIST_BY_CONTEST_TYPE_ID, getContestListByContestTypeId),
    yield takeLatest(GET_CONTEST_LIST_BY_CATEGORY, getContestListByCategory),
    yield takeLatest(GET_CONTEST_LIST_BY_CATEGORY_ID, getContestListByCategoryId),
    yield takeLeading(JOIN_WITH_MULTIPLE_TEAM, joinWithMultipleTeam),
    yield takeLeading(ADD_SUBSTITUTE_PLAYER, addSubstitutePlayer),
    yield takeLatest(GET_SUBSTITUTE_TEAM_BY_ID, getSubstituteTeamById)
  ]);
}

export default fantasySubstitute;
